import React, { useContext } from 'react'
import { Button, Spacer, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import InitiativeEventIcon from 'assets/icons/initiativeEvent'
import InitiativeGroupIcon from 'assets/icons/initiativeGroup'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const JoinWelcome = ({ onGoBack, onContinue }) => {
   const { initiative } = useContext(InitiativeHierarchyContext)
   const InitiativeIcon = initiative.class === 'event'
      ? InitiativeEventIcon
      : InitiativeGroupIcon

   // eslint-disable-next-line camelcase
   const registrationFormEnabled = initiative.apps?.registration_form?.enabled
   const admissionsCommerceEnabled = initiative.commerce.enabled

   const hasJoinRequirements = registrationFormEnabled || admissionsCommerceEnabled

   return (
      <View
         display="flex"
         justifyContent="center"
         alignItems="center"
         textAlign="center"
         width="100%"
         height="100%">
         <View width="100%[a-b] 330px[c-f]" padding="24px">
            <View
               display="inline-flex"
               justifyContent="center"
               alignItems="center"
               width="60px"
               height="60px"
               borderRadius="50%"
               backgroundColor="#e4f0ea">
               <InitiativeIcon
                  width="30px"
                  height="30px"
                  color="#23372e"
               />
            </View>
            <Spacer size="3" />
            <Text size="9" weight="normal" color="#23372e">
               {initiative.name}
            </Text>
            <Spacer size="3" />
            {!hasJoinRequirements && (
               <Text size="3" color="#555">
                  {`Click the button below to ${initiative.joinVerb} this ${initiative.type.nameSingular}`}
               </Text>
            )}
            {hasJoinRequirements && (
               <Text size="3" color="#555">
                  You must
                  {registrationFormEnabled && ' fill in a form'}
                  {registrationFormEnabled && admissionsCommerceEnabled && ' and'}
                  {admissionsCommerceEnabled && ' select a ticket'}
                  {` to ${initiative.joinVerb} this ${initiative.type.nameSingular}`}
               </Text>
            )}
            <Spacer size="5" />
            <Button
               onClick={onContinue}
               size="lg"
               color="#35b865"
               name={hasJoinRequirements ? 'Continue' : initiative.joinVerb}
               textTransform="capitalize"
            />
         </View>
      </View>
   )
}

JoinWelcome.propTypes = {
   onGoBack: PropTypes.func.isRequired,
   onContinue: PropTypes.func.isRequired
}

export default JoinWelcome
